import { getFormattedUTCDate } from "helpers";
import { t } from "i18next";
import jsPDF from "jspdf";
import autoTable, { Styles } from "jspdf-autotable";

import { ReturnDetails } from "../../returns.types";

interface renderHeaderProps {
  pdf: jsPDF;
  returnDetails?: ReturnDetails;
  bigFontStyles: Partial<Styles>;
}

export const renderHeader = ({
  pdf,
  returnDetails,
  bigFontStyles
}: renderHeaderProps) => {
  autoTable(pdf, {
    theme: "plain",
    startY: 80,
    styles: { cellPadding: 5 },
    head: [
      [
        {
          content: `${t("Order delivery date")} ${returnDetails?.deliveryDate ? getFormattedUTCDate(returnDetails.deliveryDate, "DD MMMM, YYYY") : "-"}`,
          styles: {
            ...bigFontStyles,
            halign: "center",
            fillColor: "#ffffff",
            textColor: "#000000"
          }
        }
      ]
    ],
    tableLineWidth: 1,
    tableLineColor: "#000000"
  });
};
